const ArricchimentoStructure = {

    getStructure: function () {
        return {
            section : 
            {
                name: "Compila i seguenti campi",
                id: "arricchimentoForm",
                description: "Arricchisci la segnalazione compilando i seguenti campi",
                multipleValue: false,
                rows : [
                {
                    id : "row1",
                    fields : [
                        {
                            name: "firstRelevantDate",
                            type: "date",
                            numColMd: 6,
                            label: "Prima Data Rilevante",
                            tooltipText: "",
                            required: false,
                        },
                        {
                            name: "lastRelevantDate",
                            type: "date",
                            numColMd: 6,
                            tooltipText: "",
                            label: "Ultima Data Rilevante",
                            required: false,    
                        },
                    ]
                },
                {
                    id : "row2",
                    fields : [
                        {
                            name: "sentToThirdParties",
                            type: "check",
                            numColMd: 2,
                            label: "Invio A Terzi",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "thirdPartyName",
                            type: "conditionalText",
                            numColMd: 4,
                            label: "Nome Terzo",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "estero",
                            type: "check",
                            numColMd: 2,
                            label: "Ad Autorità Estera o Altra Entità",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "foreignAuthoritiesAssignment",
                            type: "conditionalList",
                            numColMd: 4,
                            label: "Autorità Estere o Altre Entità",
                            required: false,
                            tooltipText: "",
                            choiceList : [],
                        },
                    ]
                },
                {
                    id : "row3",
                    fields : [
                        {
                            name: "briefDescription",
                            type: "textArea",
                            numColMd: 12,
                            label: "Decrizione Sintetica",
                            required: false,
                            tooltipText: "",
                        }
                    ]
                },
                {
                    id : "row4",
                    fields : [
                        {
                            name: "takingChargeDate",
                            type: "date",
                            numColMd: 6,
                            label: "Data di Presa in Carico",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "deskStorAbuso",
                            type: "choice",
                            numColMd: 6,
                            label: "Tipologia Abuso Desk Stor ",
                            required: false,
                            tooltipText: "",
                            choiceList : [],
                        },
                    ]
                },
                {
                    id : "row5",
                    fields : [
                        {
                            name: "numberOfReportedSubject",
                            type: "text",
                            numColMd: 6,
                            label: "Numero Persone Segnalate",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "numberOfReportedFinancialInstruments",
                            type: "text",
                            numColMd: 6,
                            label: "Numero Casi Riportati",
                            required: false,
                            tooltipText: "",
                        },
                    ]
                },
                {
                    id : "row6",
                    fields : [
                        {
                            name: "elapsedDays",
                            type: "text",
                            numColMd: 2,
                            label: "Ritardo Segnalazione",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "semaforo",
                            type: "traffic_light",
                            numColMd: 1,
                            label: "",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "score",
                            type: "choice",
                            numColMd: 3,
                            label: "Livello",
                            required: false,
                            tooltipText: "",
                            choiceList : [
                                "L0",
                                "L1",
                                "L2",
                                "L3",
                            ]
                        },
                        {
                            name: "calculatedScore",
                            type: "text",
                            numColMd: 3,
                            label: "Score Calcolato",
                            required: false,
                            tooltipText: "",
                        },
                        {
                            name: "triageButton",
                            type: "buttonTriage",
                            numColMd: 3,
                            label: "Assegna Livello",
                            required: false,
                            tooltipText: "",
                        },
                    ]
                },
                {
                    id : "row7",
                    fields : [
                        {
                            name: "criticalities",
                            type: "textArea",
                            numColMd: 12,
                            label: "Criticita",
                            required: false,
                            tooltipText: "",
                            newLine : true,
                        }
                    ]
                },
                {
                    id : "row8",
                    fields : [
                        {
                            name: "inputCaseOfficer",
                            type: "text",
                            numColMd: 12,
                            label: "Annotazioni per funzionari",
                            required: false,
                            tooltipText: "",
                        }
                    ]
                },
                {
                    id : "row9",
                    fields : [
                        {
                            name: "loiList",
                            type: "choice",
                            numColMd: 6,
                            label: "Lista Line of Inquiry",
                            required: false,
                            tooltipText: "",
                            choiceList : [],
                        },
                        {
                            name: "associaLoi",
                            type: "buttonAssocia",
                            numColMd: 3,
                            label: "Associa Line Of Inquiry",
                            required: false,
                            tooltipText: "",
                            
                        },
                        {
                            name: "dissociaLoi",
                            type: "buttonDissocia",
                            numColMd: 3,
                            label: "Dissocia Line of Inquiry",
                            required: false,
                            tooltipText: "",
                        }
                    ]
                },
                {
                    id : "row10",
                    fields : [
                        {
                            name: "actionsTakenByStorGroup",
                            type: "textArea",
                            numColMd: 8,
                            label: "Iniziative intraprese dal gruppo STOR",
                            required: false,
                            tooltipText: "",
                            newLine : true,
                        },
                        {
                            name: "otherUnitsToBeInformed",
                            type: "textArea",
                            numColMd: 4,
                            label: "Altre Unità Organizzative da Informare",
                            required: false,
                            tooltipText: "",
                            newLine : true,
                        }
                    ]
                },
                {
                    id : "row11",
                    fields : [
                        {
                            name: "funzionariList",
                            type: "choice",
                            numColMd: 6,
                            label: "Funzionario",
                            required: false,
                            tooltipText: "",
                            choiceList : [],
                        },
                        {
                            name: "ruoloList",
                            type: "choice",
                            numColMd: 4,
                            label: "Ruolo",
                            required: false,
                            tooltipText: "",
                            choiceList : [],
                            
                        },
                        {
                            name: "aggiungiButton",
                            type: "buttonAggiungi",
                            numColMd: 2,
                            label: "Aggiungi",
                            required: false,
                            tooltipText: "",

                            
                        },
                    ]
                }
            ]
            }  
        }
    }
}

export default ArricchimentoStructure;